// Codes are stored on risks (risk_threat_mapping, risk_vulnerability_mapping, risk_impact_dimension_mapping), so never rename one.
export const RISK_THREATS = {
  TC01: 'TC01',
  TC02: 'TC02',
  TC03: 'TC03',
  TC04: 'TC04',
  TH01: 'TH01',
  TH02: 'TH02',
  TH04: 'TH04',
  TH05: 'TH05',
  TH06: 'TH06',
  TH07: 'TH07',
  TH08: 'TH08',
  TH10: 'TH10',
  TH11: 'TH11',
  TH13: 'TH13',
  TH14: 'TH14',
  TH15: 'TH15',
  TH16: 'TH16',
  TH17: 'TH17',
  TH19: 'TH19',
  TH22: 'TH22',
  TH23: 'TH23',
  TH24: 'TH24',
  TH25: 'TH25',
  TI01: 'TI01',
  TI03: 'TI03',
  TI04: 'TI04',
  TI05: 'TI05',
  TN06: 'TN06',
  TO01: 'TO01',
  TO02: 'TO02',
  TO03: 'TO03',
  TO04: 'TO04',
  TP01: 'TP01',
  TP02: 'TP02',
  TQ01: 'TQ01',
  TQ02: 'TQ02',
  TQ03: 'TQ03',
  TQ04: 'TQ04',
  TQ05: 'TQ05',
  TQ06: 'TQ06',
  TQ07: 'TQ07',
  TQ08: 'TQ08',
  TQ09: 'TQ09',
  TQ10: 'TQ10',
  TQ11: 'TQ11',
  TQ12: 'TQ12',
  TQ13: 'TQ13',
  TQ15: 'TQ15',
  TQ16: 'TQ16',
  TQ17: 'TQ17',
  TQ20: 'TQ20',
  TQ21: 'TQ21',
  TQ22: 'TQ22',
  TQ23: 'TQ23',
  TQ24: 'TQ24',
  TQ26: 'TQ26',
  TQ27: 'TQ27',
  TT01: 'TT01',
  TT02: 'TT02',
  TT03: 'TT03',
} as const
export type IRiskThreat = (typeof RISK_THREATS)[keyof typeof RISK_THREATS]

export const RISK_VULNERABILITIES = {
  VH05: 'VH05',
  VH08: 'VH08',
  VH11: 'VH11',
  VH12: 'VH12',
  VH13: 'VH13',
  VN01: 'VN01',
  VN02: 'VN02',
  VN03: 'VN03',
  VN05: 'VN05',
  VN06: 'VN06',
  VN07: 'VN07',
  VN08: 'VN08',
  VN09: 'VN09',
  VN10: 'VN10',
  VO01: 'VO01',
  VO02: 'VO02',
  VO03: 'VO03',
  VO04: 'VO04',
  VO05: 'VO05',
  VO06: 'VO06',
  VO09: 'VO09',
  VO13: 'VO13',
  VO14: 'VO14',
  VO15: 'VO15',
  VO17: 'VO17',
  VO18: 'VO18',
  VO26: 'VO26',
  VO28: 'VO28',
  VP01: 'VP01',
  VP03: 'VP03',
  VP04: 'VP04',
  VP05: 'VP05',
  VP07: 'VP07',
  VQ01: 'VQ01',
  VQ02: 'VQ02',
  VQ03: 'VQ03',
  VQ04: 'VQ04',
  VQ05: 'VQ05',
  VQ06: 'VQ06',
  VQ07: 'VQ07',
  VQ08: 'VQ08',
  VQ09: 'VQ09',
  VQ10: 'VQ10',
  VQ11: 'VQ11',
  VQ12: 'VQ12',
  VQ14: 'VQ14',
  VQ15: 'VQ15',
  VQ16: 'VQ16',
  VQ17: 'VQ17',
  VQ19: 'VQ19',
  VQ20: 'VQ20',
  VQ21: 'VQ21',
  VQ22: 'VQ22',
  VQ23: 'VQ23',
  VQ24: 'VQ24',
  VQ25: 'VQ25',
  VQ26: 'VQ26',
  VQ27: 'VQ27',
  VS01: 'VS01',
  VS02: 'VS02',
  VS04: 'VS04',
  VS05: 'VS05',
  VS06: 'VS06',
  VS09: 'VS09',
  VS11: 'VS11',
  VS13: 'VS13',
  VS15: 'VS15',
  VS16: 'VS16',
  VS18: 'VS18',
  VS19: 'VS19',
  VS20: 'VS20',
  VS21: 'VS21',
  VS22: 'VS22',
  VS_S01: 'VS_S01',
  VS_S03: 'VS_S03',
  VS_S04: 'VS_S04',
} as const
export type IRiskVulnerability = (typeof RISK_VULNERABILITIES)[keyof typeof RISK_VULNERABILITIES]

// In display order
export const RISK_IMPACT_DIMENSIONS = {
  AVAILABILITY: 'availability',
  CONFIDENTIALITY: 'confidentiality',
  INTEGRITY: 'integrity',
  AUTHENTICITY: 'authenticity',
  TRACEABILITY: 'traceability',
} as const
export type IRiskImpactDimension = (typeof RISK_IMPACT_DIMENSIONS)[keyof typeof RISK_IMPACT_DIMENSIONS]

// Ordered values backing the `risk_impact_dimension` Postgres enum (see src/db/schema/tables/risk.ts)
export const RISK_IMPACT_DIMENSION_VALUES = [
  RISK_IMPACT_DIMENSIONS.AVAILABILITY,
  RISK_IMPACT_DIMENSIONS.CONFIDENTIALITY,
  RISK_IMPACT_DIMENSIONS.INTEGRITY,
  RISK_IMPACT_DIMENSIONS.AUTHENTICITY,
  RISK_IMPACT_DIMENSIONS.TRACEABILITY,
] as const
